import { Link } from "react-router-dom";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/lib/data";

export const CtaSection = () => (
  <section data-testid="cta-section" className="py-16 sm:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-forest px-6 py-14 sm:px-14 sm:py-20 noise-overlay">
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-primary/20 blur-3xl" aria-hidden="true" />
          <div className="relative max-w-2xl">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 mb-4">
              No obligation
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
              Let's take a proper look at your IT, free of charge.
            </h2>
            <p className="mt-4 text-base sm:text-lg text-white/70 leading-relaxed">
              A 30-minute review of your setup, security gaps and quick cost savings.
              Practical advice you keep either way, and a fast response from a real person.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Link
                to="/contact?intent=review"
                data-testid="cta-request-review-button"
                className="group inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 font-semibold text-primary-foreground transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/30 active:scale-[0.98]"
              >
                Request a Free IT Review
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
              <a
                href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
                data-testid="cta-call-button"
                className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 font-semibold text-white transition-all duration-200 hover:bg-white/10 active:scale-[0.98]"
              >
                <PhoneCall className="h-4 w-4" />
                {CONTACT.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
